interface CardProps {
  icon: any
  title: string
  content: string
  bulletItems: string[]
}

export const Card = ({ icon, title, content, bulletItems }: CardProps) => {
  const IconComponent = icon

  return (
    <>
      <IconComponent />

      <h2 className="font-myriad font-bold text-lg text-gray-900 leading-5 mt-4 mb-4">
        {title}
      </h2>
      <p className="font-myriad text-xs leading-4 text-gray-400 mb-1">
        {content}
      </p>

      {bulletItems.map(text => (
        <li key={text} className="font-myriad text-xs leading-4 text-gray-400">
          {text}
        </li>
      ))}
    </>
  )
}
